import { init, FeatureFlagMapping } from '@goldcast/feature-flags';
import { getEnvConfig } from '@/constants';
import featureFlagStore from '@/stores/featureFlagStore';

// Define the mapping of feature flag keys to their value types
export type FeatureFlagTypeMap = {
  Use_CL_AI_Debug_Tools: boolean;
  Use_CL_Show_Player_Frames: boolean;
  Use_CL_Init_New_Player_Config: boolean;
  Use_CL_Test_RS_Date: string;
  Use_CL_Uploads_In_VL: boolean;
  Use_CL_New_Recording_Studio_Timeline: boolean;
  USE_CL_FILLER_WORDS: boolean;
  Use_CL_Filler_Words_Menu: boolean;
  Use_CL_AI_Edits_Beta: boolean;
  Use_CL_Copy_Clip_To_Test_AiEdits: boolean;
  USE_CL_MERGE_TRANSCRIPT_FOR_RS: boolean;
  Use_CL_New_HomePage: boolean;
  Use_CL_Timeline_Add_Menu: boolean;
  Use_CL_Multi_Word_Edit_Transcript_No_Srt_Check: boolean;
  Use_CL_Face_Rec_To_Default_Position: boolean;
  Use_CL_New_AI_Search: boolean;
  Use_CL_workspace_filters: boolean;
  Use_CL_Replace_Audio: boolean;
  Use_CL_Replace_Video_Overlays: boolean;
  Use_CL_Show_Person_and_Face_Coordinates_in_Manual_Reposition: boolean;
  Use_CL_Person_Container: boolean;
  Use_CL_Splits_In_Timeline: boolean;
  Use_CL_Overlay_Layering: boolean;
  Use_CL_Screenshare_Detection: boolean;
  Use_CL_Audio_Transitions: boolean;
  Use_CL_Segment_Transitions: boolean;
  Use_CL_New_Video_Tag_In_Preview: boolean;
  Use_CL_Platform_Brandkit: boolean;
  Use_CL_Branded_Presets: boolean;
  Use_CL_Download_Revamp: boolean;
  Use_CL_Audio_Controls: boolean;
  Use_CL_Playback_Speed: boolean;
  Use_Pauses_Enhancements: boolean;
  Use_CL_Splits_Translations: boolean;
  Use_CL_Fullvideo_Facerec: boolean;
  Use_CL_Fullvideo_Facerec_Pre_Recorded: boolean;
  Use_CL_Multi_Select_Assets: boolean;
  Use_Signed_Filestack_Uploads: boolean;
  Use_CL_Play_Range_Micro_Cuts: boolean;
  Use_CL_Clip_Duplication: boolean;
  Use_CL_Simplified_Upload: boolean;
  Use_CL_Chapters_In_Menu: boolean;
  Use_CL_Express_Service: boolean;
  Use_CL_Text_Assets_Grouping: boolean;
  Use_CL_Overlays_Grouping: boolean;
  Use_CL_Editor_New_Layouts: boolean;
  Use_CL_Layout_Fit_Fill_Cards: boolean;
};

export enum FeatureFlagKeys {
  /* PERMANENT FLAGS */
  Use_CL_AI_Debug_Tools = 'Use_CL_AI_Debug_Tools',
  /* TEMPORARY FLAGS */
  Use_CL_Show_Player_Frames = 'Use_CL_Show_Player_Frames',
  Use_CL_Init_New_Player_Config = 'Use_CL_Init_New_Player_Config',
  Use_CL_Test_RS_Date = 'Use_CL_Test_RS_Date',
  Use_CL_Uploads_In_VL = 'Use_CL_Uploads_In_VL',
  Use_CL_New_Recording_Studio_Timeline = 'Use_CL_New_Recording_Studio_Timeline',
  USE_CL_FILLER_WORDS = 'USE_CL_FILLER_WORDS',
  Use_CL_Filler_Words_Menu = 'Use_CL_Filler_Words_Menu',
  Use_CL_AI_Edits_Beta = 'Use_CL_AI_Edits_Beta',
  Use_CL_Copy_Clip_To_Test_AiEdits = 'Use_CL_Copy_Clip_To_Test_AiEdits',
  USE_CL_MERGE_TRANSCRIPT_FOR_RS = 'USE_CL_MERGE_TRANSCRIPT_FOR_RS',
  Use_CL_New_HomePage = 'Use_CL_New_HomePage',
  Use_CL_Timeline_Add_Menu = 'Use_CL_Timeline_Add_Menu',
  Use_CL_Multi_Word_Edit_Transcript_No_Srt_Check = 'Use_CL_Multi_Word_Edit_Transcript_No_Srt_Check',
  Use_CL_Face_Rec_To_Default_Position = 'Use_CL_Face_Rec_To_Default_Position',
  Use_CL_New_AI_Search = 'Use_CL_New_AI_Search',
  Use_CL_workspace_filters = 'Use_CL_workspace_filters',
  Use_CL_Replace_Audio = 'Use_CL_Replace_Audio',
  Use_CL_Replace_Video_Overlays = 'Use_CL_Replace_Video_Overlays',
  Use_CL_Show_Person_and_Face_Coordinates_in_Manual_Reposition = 'Use_CL_Show_Person_and_Face_Coordinates_in_Manual_Reposition',
  Use_CL_Person_Container = 'Use_CL_Person_Container',
  Use_CL_Splits_In_Timeline = 'Use_CL_Splits_In_Timeline',
  Use_CL_Overlay_Layering = 'Use_CL_Overlay_Layering',
  Use_CL_Screenshare_Detection = 'Use_CL_Screenshare_Detection',
  Use_CL_Audio_Transitions = 'Use_CL_Audio_Transitions',
  Use_CL_Segment_Transitions = 'Use_CL_Segment_Transitions',
  Use_CL_New_Video_Tag_In_Preview = 'Use_CL_New_Video_Tag_In_Preview',
  Use_CL_Platform_Brandkit = 'Use_CL_Platform_Brandkit',
  Use_CL_Branded_Presets = 'Use_CL_Branded_Presets',
  Use_CL_Download_Revamp = 'Use_CL_Download_Revamp',
  Use_CL_Audio_Controls = 'Use_CL_Audio_Controls',
  Use_CL_Playback_Speed = 'Use_CL_Playback_Speed',
  Use_Pauses_Enhancements = 'Use_Pauses_Enhancements',
  Use_CL_Splits_Translations = 'Use_CL_Splits_Translations',
  Use_CL_Fullvideo_Facerec = 'Use_CL_Fullvideo_Facerec',
  Use_CL_Fullvideo_Facerec_Pre_Recorded = 'Use_CL_Fullvideo_Facerec_Pre_Recorded',
  Use_CL_Multi_Select_Assets = 'Use_CL_Multi_Select_Assets',
  Use_Signed_Filestack_Uploads = 'Use_Signed_Filestack_Uploads',
  Use_CL_Simplified_Upload = 'Use_CL_Simplified_Upload',
  Use_CL_Play_Range_Micro_Cuts = 'Use_CL_Play_Range_Micro_Cuts',
  Use_CL_Clip_Duplication = 'Use_CL_Clip_Duplication',
  Use_CL_Chapters_In_Menu = 'Use_CL_Chapters_In_Menu',
  Use_CL_Express_Service = 'Use_CL_Express_Service',
  Use_CL_Text_Assets_Grouping = 'Use_CL_Text_Assets_Grouping',
  Use_CL_Overlays_Grouping = 'Use_CL_Overlays_Grouping',
  Use_CL_Editor_New_Layouts = 'Use_CL_Editor_New_Layouts',
  Use_CL_Layout_Fit_Fill_Cards = 'Use_CL_Layout_Fit_Fill_Cards'
}

export const handleFlagValueChange =
  <T extends keyof FeatureFlagTypeMap>(flag: T) =>
  (value: FeatureFlagTypeMap[T]) => {
    featureFlagStore.update(data => ({
      ...data,
      [flag]: value
    }));
  };

export const featureFlags = (): FeatureFlagMapping<FeatureFlagTypeMap> => ({
  [FeatureFlagKeys.Use_CL_AI_Debug_Tools]: {
    value: false,
    changeHandler: handleFlagValueChange(FeatureFlagKeys.Use_CL_AI_Debug_Tools)
  },
  [FeatureFlagKeys.Use_CL_Show_Player_Frames]: {
    value: false,
    changeHandler: handleFlagValueChange(FeatureFlagKeys.Use_CL_Show_Player_Frames)
  },
  [FeatureFlagKeys.Use_CL_Init_New_Player_Config]: {
    value: false,
    changeHandler: handleFlagValueChange(FeatureFlagKeys.Use_CL_Init_New_Player_Config)
  },
  [FeatureFlagKeys.Use_CL_Test_RS_Date]: {
    value: '',
    changeHandler: handleFlagValueChange(FeatureFlagKeys.Use_CL_Test_RS_Date)
  },
  [FeatureFlagKeys.Use_CL_Uploads_In_VL]: {
    value: false,
    changeHandler: handleFlagValueChange(FeatureFlagKeys.Use_CL_Uploads_In_VL)
  },
  [FeatureFlagKeys.Use_CL_New_Recording_Studio_Timeline]: {
    value: false,
    changeHandler: handleFlagValueChange(FeatureFlagKeys.Use_CL_New_Recording_Studio_Timeline)
  },
  [FeatureFlagKeys.USE_CL_FILLER_WORDS]: {
    value: false,
    changeHandler: handleFlagValueChange(FeatureFlagKeys.USE_CL_FILLER_WORDS)
  },
  [FeatureFlagKeys.Use_CL_Filler_Words_Menu]: {
    value: false,
    changeHandler: handleFlagValueChange(FeatureFlagKeys.Use_CL_Filler_Words_Menu)
  },
  [FeatureFlagKeys.Use_CL_AI_Edits_Beta]: {
    value: false,
    changeHandler: handleFlagValueChange(FeatureFlagKeys.Use_CL_AI_Edits_Beta)
  },
  [FeatureFlagKeys.Use_CL_Copy_Clip_To_Test_AiEdits]: {
    value: false,
    changeHandler: handleFlagValueChange(FeatureFlagKeys.Use_CL_Copy_Clip_To_Test_AiEdits)
  },
  [FeatureFlagKeys.USE_CL_MERGE_TRANSCRIPT_FOR_RS]: {
    value: false,
    changeHandler: handleFlagValueChange(FeatureFlagKeys.USE_CL_MERGE_TRANSCRIPT_FOR_RS)
  },
  [FeatureFlagKeys.Use_CL_New_HomePage]: {
    value: false,
    changeHandler: handleFlagValueChange(FeatureFlagKeys.Use_CL_New_HomePage)
  },
  [FeatureFlagKeys.Use_CL_Timeline_Add_Menu]: {
    value: false,
    changeHandler: handleFlagValueChange(FeatureFlagKeys.Use_CL_Timeline_Add_Menu)
  },
  [FeatureFlagKeys.Use_CL_Multi_Word_Edit_Transcript_No_Srt_Check]: {
    value: false,
    changeHandler: handleFlagValueChange(FeatureFlagKeys.Use_CL_Multi_Word_Edit_Transcript_No_Srt_Check)
  },
  [FeatureFlagKeys.Use_CL_Face_Rec_To_Default_Position]: {
    value: false,
    changeHandler: handleFlagValueChange(FeatureFlagKeys.Use_CL_Face_Rec_To_Default_Position)
  },
  [FeatureFlagKeys.Use_CL_New_AI_Search]: {
    value: false,
    changeHandler: handleFlagValueChange(FeatureFlagKeys.Use_CL_New_AI_Search)
  },
  [FeatureFlagKeys.Use_CL_workspace_filters]: {
    value: false,
    changeHandler: handleFlagValueChange(FeatureFlagKeys.Use_CL_workspace_filters)
  },
  [FeatureFlagKeys.Use_CL_Replace_Audio]: {
    value: false,
    changeHandler: handleFlagValueChange(FeatureFlagKeys.Use_CL_Replace_Audio)
  },
  [FeatureFlagKeys.Use_CL_Replace_Video_Overlays]: {
    value: false,
    changeHandler: handleFlagValueChange(FeatureFlagKeys.Use_CL_Replace_Video_Overlays)
  },
  [FeatureFlagKeys.Use_CL_Show_Person_and_Face_Coordinates_in_Manual_Reposition]: {
    value: false,
    changeHandler: handleFlagValueChange(FeatureFlagKeys.Use_CL_Show_Person_and_Face_Coordinates_in_Manual_Reposition)
  },
  [FeatureFlagKeys.Use_CL_Person_Container]: {
    value: false,
    changeHandler: handleFlagValueChange(FeatureFlagKeys.Use_CL_Person_Container)
  },
  [FeatureFlagKeys.Use_CL_Splits_In_Timeline]: {
    value: false,
    changeHandler: handleFlagValueChange(FeatureFlagKeys.Use_CL_Splits_In_Timeline)
  },
  [FeatureFlagKeys.Use_CL_Overlay_Layering]: {
    value: false,
    changeHandler: handleFlagValueChange(FeatureFlagKeys.Use_CL_Overlay_Layering)
  },
  [FeatureFlagKeys.Use_CL_Screenshare_Detection]: {
    value: false,
    changeHandler: handleFlagValueChange(FeatureFlagKeys.Use_CL_Screenshare_Detection)
  },
  [FeatureFlagKeys.Use_CL_Audio_Transitions]: {
    value: false,
    changeHandler: handleFlagValueChange(FeatureFlagKeys.Use_CL_Audio_Transitions)
  },
  [FeatureFlagKeys.Use_CL_Segment_Transitions]: {
    value: false,
    changeHandler: handleFlagValueChange(FeatureFlagKeys.Use_CL_Segment_Transitions)
  },
  [FeatureFlagKeys.Use_CL_New_Video_Tag_In_Preview]: {
    value: false,
    changeHandler: handleFlagValueChange(FeatureFlagKeys.Use_CL_New_Video_Tag_In_Preview)
  },
  [FeatureFlagKeys.Use_CL_Platform_Brandkit]: {
    value: false,
    changeHandler: handleFlagValueChange(FeatureFlagKeys.Use_CL_Platform_Brandkit)
  },
  [FeatureFlagKeys.Use_CL_Branded_Presets]: {
    value: false,
    changeHandler: handleFlagValueChange(FeatureFlagKeys.Use_CL_Branded_Presets)
  },
  [FeatureFlagKeys.Use_CL_Download_Revamp]: {
    value: false,
    changeHandler: handleFlagValueChange(FeatureFlagKeys.Use_CL_Download_Revamp)
  },
  [FeatureFlagKeys.Use_CL_Audio_Controls]: {
    value: false,
    changeHandler: handleFlagValueChange(FeatureFlagKeys.Use_CL_Audio_Controls)
  },
  [FeatureFlagKeys.Use_CL_Playback_Speed]: {
    value: false,
    changeHandler: handleFlagValueChange(FeatureFlagKeys.Use_CL_Playback_Speed)
  },
  [FeatureFlagKeys.Use_Pauses_Enhancements]: {
    value: false,
    changeHandler: handleFlagValueChange(FeatureFlagKeys.Use_Pauses_Enhancements)
  },
  [FeatureFlagKeys.Use_CL_Splits_Translations]: {
    value: false,
    changeHandler: handleFlagValueChange(FeatureFlagKeys.Use_CL_Splits_Translations)
  },
  [FeatureFlagKeys.Use_CL_Fullvideo_Facerec]: {
    value: false,
    changeHandler: handleFlagValueChange(FeatureFlagKeys.Use_CL_Fullvideo_Facerec)
  },
  [FeatureFlagKeys.Use_CL_Fullvideo_Facerec_Pre_Recorded]: {
    value: false,
    changeHandler: handleFlagValueChange(FeatureFlagKeys.Use_CL_Fullvideo_Facerec_Pre_Recorded)
  },
  [FeatureFlagKeys.Use_CL_Multi_Select_Assets]: {
    value: false,
    changeHandler: handleFlagValueChange(FeatureFlagKeys.Use_CL_Multi_Select_Assets)
  },
  [FeatureFlagKeys.Use_Signed_Filestack_Uploads]: {
    value: true,
    changeHandler: handleFlagValueChange(FeatureFlagKeys.Use_Signed_Filestack_Uploads)
  },
  [FeatureFlagKeys.Use_CL_Simplified_Upload]: {
    value: false,
    changeHandler: handleFlagValueChange(FeatureFlagKeys.Use_CL_Simplified_Upload)
  },
  [FeatureFlagKeys.Use_CL_Play_Range_Micro_Cuts]: {
    value: false,
    changeHandler: handleFlagValueChange(FeatureFlagKeys.Use_CL_Play_Range_Micro_Cuts)
  },
  [FeatureFlagKeys.Use_CL_Clip_Duplication]: {
    value: false,
    changeHandler: handleFlagValueChange(FeatureFlagKeys.Use_CL_Clip_Duplication)
  },
  [FeatureFlagKeys.Use_CL_Chapters_In_Menu]: {
    value: false,
    changeHandler: handleFlagValueChange(FeatureFlagKeys.Use_CL_Chapters_In_Menu)
  },
  [FeatureFlagKeys.Use_CL_Express_Service]: {
    value: false,
    changeHandler: handleFlagValueChange(FeatureFlagKeys.Use_CL_Express_Service)
  },
  [FeatureFlagKeys.Use_CL_Text_Assets_Grouping]: {
    value: false,
    changeHandler: handleFlagValueChange(FeatureFlagKeys.Use_CL_Text_Assets_Grouping)
  },
  [FeatureFlagKeys.Use_CL_Overlays_Grouping]: {
    value: false,
    changeHandler: handleFlagValueChange(FeatureFlagKeys.Use_CL_Overlays_Grouping)
  },
  [FeatureFlagKeys.Use_CL_Editor_New_Layouts]: {
    value: false,
    changeHandler: handleFlagValueChange(FeatureFlagKeys.Use_CL_Editor_New_Layouts)
  },
  [FeatureFlagKeys.Use_CL_Layout_Fit_Fill_Cards]: {
    value: false,
    changeHandler: handleFlagValueChange(FeatureFlagKeys.Use_CL_Layout_Fit_Fill_Cards)
  }
});

// store promise in var for cases of calling this function from multiple places
let initializationPromise: Promise<void> | null = null;

export const initializeFeatureFlags = user => {
  if (featureFlagStore.getSnapshot().areFlagsLoaded) {
    return Promise.resolve();
  }
  if (!initializationPromise) {
    initializationPromise = new Promise<void>((resolve, reject) => {
      init<FeatureFlagTypeMap>(
        getEnvConfig('APP_HARNESS_SECRET') || '',
        {
          identifier: user.id || 'anonymous',
          name: `${user.first_name} ${user.last_name}` || 'anonymous',
          attributes: {
            role: 2, // admin role
            event: '',
            eventOrganization: user.organization,
            is_content_lab_standalone: user.is_content_lab_standalone,
            appHostname: window.location?.hostname
          }
        },
        featureFlags(),
        {
          ready: () => {
            featureFlagStore.update(data => ({ ...data, areFlagsLoaded: true }));
            return resolve();
          },
          errored: () => {
            featureFlagStore.update(data => ({ ...data, areFlagsLoaded: true }));
            return reject();
          },
          errorAuth: () => {
            featureFlagStore.update(data => ({ ...data, areFlagsLoaded: true }));
            return reject();
          }
        }
      );
    });
  }
  return initializationPromise;
};
